import * as React from "react";
import { hot } from "react-hot-loader";
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import DataProvider from '../../dataproviders/DataProvider';
import IApiResponse from '../../interfaces/IApiResponse';
import { IInputFormSharePoint } from '../../interfaces/IInputFormSharePoint';
import IUser from '../../interfaces/IUser';
import CustomInput from '../CustomInput/CustomInput';
import { CustomInputService } from '../CustomInput/CustomInputService';
import CustomLoader from '../CustomLoader/CustomLoader';
import { IInscriptionState } from './IInscriptionState';
declare var configcustoms: any;
declare var libelle: any;

class Inscription extends React.Component<{}, IInscriptionState> {

    private _dataProvider = new DataProvider();

    private lastNameKey = 'LastName';
    private firstNameKey = 'FirstName';
    private emailKey = 'Email';
    private emailRepeatKey = 'EmailRepeat';

    constructor(props) {
        super(props);

        this._dataProvider = new DataProvider();

        // Init input validation
        const inputValidationInit = CustomInputService.inputValidationInit();

        // Init input form
        const inputFormInit = CustomInputService.inputFormInit(inputValidationInit);

        // Init submited resp
        const submitedRespInit: IApiResponse<string> = {
            Message: '',
            State: '',
            Content: ''
        }

        const inputFormListInit: IInputFormSharePoint[] = [];

        inputFormListInit[this.lastNameKey] = {
            ...inputFormInit,
            Name: 'LastName',
            PlaceHolder: libelle.inscription.form.placeHolderLastName,
            Label: libelle.inscription.form.labelLastName,
            InputValidation: {
                ...inputValidationInit,
                IsRequired: true,
                IsRequiredMessage: libelle.inscription.form.isRequiredMessage,
            }
        }

        inputFormListInit[this.firstNameKey] = {
            ...inputFormInit,
            Name: 'FirstName',
            PlaceHolder: libelle.inscription.form.placeHolderFirstName,
            Label: libelle.inscription.form.labelFirstName,
            InputValidation: {
                ...inputValidationInit,
                IsRequired: true,
                IsRequiredMessage: libelle.inscription.form.isRequiredMessage,
            }
        }

        inputFormListInit[this.emailKey] = {
            ...inputFormInit,
            Name: 'Email',
            PlaceHolder: libelle.inscription.form.placeHolderEmail,
            Label: libelle.inscription.form.labelEmail,
            Type: 'email',
            InputValidation: {
                ...inputValidationInit,
                IsRequired: true,
                IsRequiredMessage: libelle.inscription.form.isRequiredMessage,
                IsEmail: true,
                IsEmailMessage: libelle.inscription.form.isEmailMessage,
            }
        }

        inputFormListInit[this.emailRepeatKey] = {
            ...inputFormInit,
            Name: 'EmailRepeat',
            PlaceHolder: libelle.inscription.form.placeHolderEmailRepeat,
            Label: libelle.inscription.form.labelEmailRepeat,
            Type: 'email',
            DisabledPaste: true,
            DisabledAutoComplet: true,
            InputValidation: {
                ...inputValidationInit,
                IsRequired: true,
                IsRequiredMessage: libelle.inscription.form.isRequiredMessage,
                IsEmail: true,
                IsEmailMessage: libelle.inscription.form.isEmailMessage,
                IsEqualsToInput: 'Email',
                IsEqualsToInputMessage: libelle.inscription.form.isEqualsToInputMailMessage
            }
        }

        // Init du state
        this.state = {
            IsValidForm: false,
            IsFirstSubmit: true,
            IsSubmitedResp: submitedRespInit,
            InputFormList: inputFormListInit,
            IsReady: true,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public componentDidMount() {
        this.formValidation();
    }


    public render() {

        return (
            <div id="inscription">
                <CSSTransition
                    classNames="loader"
                    in={!this.state.IsReady}
                    timeout={300}
                    unmountOnExit={true}
                >
                    <CustomLoader />
                </CSSTransition>
                <CSSTransition
                    classNames="fadein"
                    in={this.state.IsReady && this.state.IsSubmitedResp.State !== 'OK'}
                    timeout={300}
                    unmountOnExit={true}
                >
                    <div className="row">
                        <div className="col-12 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 ">
                            <h1>{libelle.inscription.title}</h1>
                            <div className="custom-card p-4">
                                <p>{libelle.inscription.infos}</p>
                                <p className="mb-0">{libelle.inscription.infos2}</p>
                                {this.state.IsSubmitedResp.State === 'KO' &&
                                    <p className="mt-1 mb-0 text-danger">
                                        {libelle.inscription.errorCreateUser}
                                    </p>
                                }
                                {this.state.IsSubmitedResp.State === 'KO_EMAIL_EXIST' &&
                                    <p className="mt-1 mb-0 text-danger">
                                        {libelle.inscription.errorCreateUserEmailExist}
                                    </p>
                                }
                            </div>
                            <form className="pt-4" onSubmit={this.handleSubmit} noValidate={true}>
                                <CustomInput HandleChange={this.handleChange} InputForm={this.state.InputFormList[this.lastNameKey]} IsFirstSubmit={this.state.IsFirstSubmit} />
                                <CustomInput HandleChange={this.handleChange} InputForm={this.state.InputFormList[this.firstNameKey]} IsFirstSubmit={this.state.IsFirstSubmit} />
                                <CustomInput HandleChange={this.handleChange} InputForm={this.state.InputFormList[this.emailKey]} IsFirstSubmit={this.state.IsFirstSubmit} />
                                <CustomInput HandleChange={this.handleChange} InputForm={this.state.InputFormList[this.emailRepeatKey]} IsFirstSubmit={this.state.IsFirstSubmit} />
                                <div className="pt-4 d-flex flex-nowrap justify-content-between">
                                    <Link to={configcustoms.Route.Home} >{libelle.inscription.btnCancel}</Link>
                                    <button type="submit" className="btn btn-primary btn-lg">{libelle.inscription.btnCreateUser}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </CSSTransition>
                <CSSTransition
                    classNames="fadein"
                    in={this.state.IsReady && this.state.IsSubmitedResp.State === 'OK'}
                    timeout={300}
                    unmountOnExit={true}
                >
                    <div className="row">
                        <div className="col-12 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 ">
                            <h1>{libelle.inscription.title}</h1>
                            <div className="custom-card p-4">
                                <p>{libelle.inscription.successMessage}</p>
                                <p className="mb-0"><b>{this.state.InputFormList[this.emailKey].Value}</b></p>
                            </div>
                            <div className="pt-4 d-flex flex-nowrap flex-row-reverse">
                                <Link to={configcustoms.Route.Home}>
                                    <button type="button" className="btn btn-primary btn-lg">{libelle.inscription.btnGoToHome}</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </CSSTransition>
            </div>
        );
    }

    private handleChange(event) {
        let state = {
            ...this.state,
            InputFormList: {
                ...this.state.InputFormList,
                [event.target.name]: CustomInputService.validInput(this.state.InputFormList[event.target.name], event.target.value, this.state.InputFormList)
            }
        };

        if (event.target.name === this.emailKey) {
            state = {
                ...this.state,
                InputFormList: {
                    ...this.state.InputFormList,
                    [this.emailRepeatKey]: CustomInputService.validInput(this.state.InputFormList[this.emailRepeatKey], this.state.InputFormList[this.emailRepeatKey].Value, this.state.InputFormList)
                }
            };
        }

        this.setState(state);
    }

    private handleSubmit(event) {
        event.preventDefault();

        if (this.formValidation()) {
            this.createUser();
        }
    }

    private formValidation(): boolean {

        let isValidForm = true;
        let isFirstSubmit = this.state.IsFirstSubmit;

        if (isFirstSubmit) {
            isFirstSubmit = false;
        }

        Object.keys(this.state.InputFormList).map(key => {
            const inputCheck = CustomInputService.validInput(this.state.InputFormList[key], this.state.InputFormList[key].Value, this.state.InputFormList);
            if (!inputCheck.IsValid) {
                isValidForm = false;
            }
        });

        this.setState({ IsValidForm: isValidForm, IsFirstSubmit: isFirstSubmit });

        return isValidForm;
    }

    private createUser() {
        this.setState({ IsReady: false });

        const user: IUser = {
            Email: this.state.InputFormList[this.emailKey].Value,
            FirstName: this.state.InputFormList[this.firstNameKey].Value,
            LastName: this.state.InputFormList[this.lastNameKey].Value,
            Password: '',
            Key: '',
            Login: ''
        };

        this._dataProvider.createUser(user).then((resp: IApiResponse<string>) => {
            this.setState({ IsReady: true, IsSubmitedResp: resp });
        })
    }

}

export default hot(module)(Inscription);
